import MainNavItem from './MainNavItem'
import useActiveNavItemIndex from 'hooks/useActiveNavItemIndex'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
import { AchievePage } from '@/utils/environmentConfig'

const ACHIEVE_PRO_ROUTE = '/achieve-pro'

/**
 * @param {{
 *  condensed: boolean|false
 *  disabledRoutes: []
 *  items: []
 *  mobileNavOpen: boolean|false
 * }} props
 */
export default function Navigation({
  condensed = false,
  mobileNavOpen = false,
  items,
  disabledRoutes = [],
  disabledElements = [],
  mobileSubnav,
  className,
  titleVariant = 'bodyLg',
  titleMobileVariant = 'bodyLg',
  subNavClassName,
  titleClassName,
  subNavTitleClassName,
  siteEnv,
  onItemClick,
}) {
  let [activeItemIndex] = useActiveNavItemIndex()
  const { dynamicPathname } = useAppRouter()
  const isAchievePro = siteEnv === AchievePage && dynamicPathname?.startsWith(ACHIEVE_PRO_ROUTE)

  const filterSubNavsIfAllRoutesAreDisabled = (subNavs) => {
    return (
      subNavs
        .filter((subNavMain) => {
          let urls = []
          if (!subNavMain?.subNavMenus) return true
          //Gets a list of urls contained within sub menu Items
          for (let subNav of subNavMain.subNavMenus[0].menuItems) {
            if (subNav?.url) {
              urls.push(subNav.url)
            }
          }

          //Removes sub menus with no routes available
          return !(
            urls.filter((url) => {
              return !disabledRoutes.includes(url)
            }).length === 0
          )
        })
        //This mapping logic returns JSX corresponding to sub menus available
        .map((props, i) => (
          <MainNavItem
            itemIndex={i}
            key={i}
            currentPathname={dynamicPathname}
            {...props}
            disabledRoutes={disabledRoutes}
            disabledElements={disabledElements}
            titleVariant={titleVariant}
            titleMobileVariant={titleMobileVariant}
            subNavClassName={subNavClassName}
            titleClassName={titleClassName}
            subNavTitleClassName={subNavTitleClassName}
            siteEnv={siteEnv}
            onItemClick={onItemClick}
            isAchievePro={isAchievePro}
          />
        ))
    )
  }

  return (
    <nav
      className={classNames(
        AchievePage === siteEnv
          ? 'bg-white max-lg:group-data-[mobile-nav-open=true]:bg-black  border-t-neutral-75 border-sold border-b-0 border-x-0 h-full overflow-scroll pb-40 pt-[84px] fixed top-0 left-0 -translate-y-full [transition:transform_400ms_cubic-bezier(0,0,0.2,1),background-color_400ms_cubic-bezier(0,0,0.2,1)] w-full'
          : 'bg-white border-t-neutral-75 border-sold border-b-0 border-x-0 h-full overflow-scroll pb-40 pt-[54px] fixed -right-full [transition:transform_250ms_cubic-bezier(0.4,0,0.2,1)] w-full',
        AchievePage === siteEnv
          ? 'data-[mobile-nav-open=true]:translate-y-0'
          : 'data-[mobile-nav-open=true]:-translate-x-full',
        '[&>ul]:flex [&>ul]:flex-col [&>ul]:list-none [&>ul]:m-0 [&>ul]:p-0',
        AchievePage === siteEnv
          ? 'lg:border-none lg:border-0 lg:h-full lg:[overflow:initial] lg:py-0 lg:relative lg:right-0 lg:left-auto lg:top-0 lg:w-auto lg:translate-y-0 lg:[transition:none]'
          : 'lg:border-none lg:border-0 lg:h-full lg:[overflow:initial] lg:py-0 lg:relative lg:right-0 lg:top-0 lg:w-auto lg:[transition:none]',
        'lg:data-[mobile-nav-open=true]:translate-none',
        'lg:[&>ul]:items-stretch lg:[&>ul]:h-full lg:[&>ul]:flex-row',
        AchievePage === siteEnv &&
          'max-lg:group-data-[mobile-nav-open=true]:flex max-lg:group-data-[mobile-nav-open=true]:flex-col max-lg:group-data-[mobile-nav-open=true]:h-full max-lg:group-data-[mobile-nav-open=true]:justify-between max-lg:group-data-[mobile-nav-open=true]:px-5 max-lg:group-data-[mobile-nav-open=true]:pb-10',
        className
      )}
      data-condensed={condensed}
      data-mobile-nav-open={mobileNavOpen}
      data-subnav-open={activeItemIndex >= 0}
    >
      <ul
        className={
          AchievePage === siteEnv &&
          'max-lg:group-data-[mobile-nav-open=true]:border-t-[#C0CBD8] max-lg:group-data-[mobile-nav-open=true]:border-t max-lg:group-data-[mobile-nav-open=true]:border-solid max-lg:group-data-[mobile-nav-open=true]:border-b-0 max-lg:group-data-[mobile-nav-open=true]:border-x-0 max-lg:group-data-[mobile-nav-open=true]:py-4!'
        }
      >
        {filterSubNavsIfAllRoutesAreDisabled(items)}
      </ul>
      {mobileSubnav}
    </nav>
  )
}

Navigation.propTypes = {
  condensed: PropTypes.bool,
  disabledRoutes: PropTypes.array,
  disabledElements: PropTypes.object,
  mobileNavOpen: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
}
